// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"115":"students","300":"verify","687":"remove","936":"registration"}[chunkId] || chunkId) + "." + {"115":"d87970a4","300":"e9f95098","650":"15f5b051","687":"b7bef5cb","936":"60b3dbe9"}[chunkId] + ".js";
};